import request from '../kernel/request'

export default {
	record: {
		list(params) {
			return request.get('expend/record', params)
		},
		page(params) {
			return request.get('expend/record/page', params)
		},
		stat(params) {
			return request.get('expend/record/stat', params)
		},
		leader(params) {
			return request.get('expend/record/leader', params)
		},
		boss(params) {
			return request.get('expend/record/boss', params)
		},
		finance(params) {
			return request.get('expend/record/finance', params)
		},
		financeStat(params) {
			return request.get('expend/record/finance/stat', params)
		},
		my(params) {
			return request.get('expend/record/myPage', params)
		},
		save(data) {
			return request.post(`expend/record/save`, data)
		},
		update(data) {
			return request.put(`expend/record/update`, data)
		},
		financeUp(data) {
			return request.put(`expend/record/finance/update`, data)
		},
		upTwoType(data) {
			return request.put(`expend/record/update/twoType`, data)
		},
		delete(id) {
			return request.delete('expend/record/' + id)
		},
		remove(id) {
			return request.delete('expend/record/remove/' + id)
		},
		loadBy(id) {
			return request.get('expend/record/loadBy/' + id)
		},
		financeAll(id) {
			return request.get('expend/record/financeAll/' + id)
		},
		notPass(id) {
			return request.get('expend/record/notPass/' + id)
		},
		load(id) {
			return request.get('expend/record/' + id)
		},
		uploadFinance: `${request.baseURL}/expend/record/uploadFinance`,
		uploadSource: `${request.baseURL}/expend/record/uploadSource`,
		uploadExpend: `${request.baseURL}/expend/record/uploadExpend`,
		uploadInvoice: `${request.baseURL}/expend/record/uploadInvoice`,
		uploadAttachment: `${request.baseURL}/expend/record/uploadAttachment`,
	},
	catalog: {
		list(params) {
			return request.get('expend/catalog', params)
		},
		save(data) {
			return request.post(`expend/catalog/save`, data)
		},
		upCatalog(data) {
			return request.put(`expend/catalog/upCatalog`, data)
		},
		update(data) {
			return request.put(`expend/catalog`, data)
		},
		delete(id) {
			return request.delete('expend/catalog/' + id)
		},
		load(id) {
			return request.get('expend/catalog/' + id)
		}
	},
	number: {
		list(params) {
			return request.get('expend/number/list', params)
		},
		save(data) {
			return request.post(`expend/number/save`, data)
		},
		update(data) {
			return request.put(`expend/number`, data)
		},
		delete(id) {
			return request.delete('expend/number/' + id)
		},
		load(id) {
			return request.get('expend/number/' + id)
		}
	},
	bank: {
		list(params) {
			return request.get('expend/bank/list', params)
		},
		save(data) {
			return request.post(`expend/bank`, data)
		},
		update(data) {
			return request.put(`expend/bank`, data)
		},
		delete(id) {
			return request.delete('expend/bank/' + id)
		},
		load(id) {
			return request.get('expend/bank/' + id)
		}
	},
	college: {
		list(params) {
			return request.get('expend/college/list', params)
		},
		page(params) {
			return request.get('expend/college/page', params)
		},
		save(data) {
			return request.post(`expend/college`, data)
		},
		update(data) {
			return request.put(`expend/college`, data)
		},
		delete(id) {
			return request.delete('expend/college/' + id)
		},
		load(id) {
			return request.get('expend/college/' + id)
		}
	},
	section: {
		list(params) {
			return request.get('expend/section/list', params)
		},
		save(data) {
			return request.post(`expend/section/save`, data)
		},
		update(data) {
			return request.put(`expend/section`, data)
		},
		delete(id) {
			return request.delete('expend/section/' + id)
		},
		load(id) {
			return request.get('expend/section/' + id)
		}
	},
	audit: {
		list(params) {
			return request.get('expend/audit', params)
		},
		listBy(id) {
			return request.get('expend/audit/listBy/' + id)
		},
		save(data) {
			return request.post(`expend/audit/save`, data)
		},
		update(data) {
			return request.put(`expend/audit`, data)
		},
		delete(id) {
			return request.delete('expend/audit/' + id)
		},
		load(id) {
			return request.get('expend/audit/' + id)
		}
	},
	remit: {
		list(params) {
			return request.get('expend/remit', params)
		},
		save(data) {
			return request.post(`expend/remit/save`, data)
		},
		update(data) {
			return request.put(`expend/remit`, data)
		},
		delete(id) {
			return request.delete('expend/remit/' + id)
		},
		load(id) {
			return request.get('expend/remit/' + id)
		}
	}
}